import { Certificate } from '../types';

export const certificates: Certificate[] = [
  {
    id: 'placeholder-1',
    name: '[أضف اسم الشهادة]',
    issuer: '[أضف الجهة المانحة]',
    date: '[أضف التاريخ]',
    credentialId: '[أضف رقم الاعتماد]',
    credentialUrl: '[أضف رابط الاعتماد]',
    image: '/images/certificates/placeholder.png',
  },
  {
    id: 'placeholder-2',
    name: '[أضف اسم الشهادة]',
    issuer: '[أضف الجهة المانحة]',
    date: '[أضف التاريخ]',
    credentialId: '[أضف رقم الاعتماد]',
    credentialUrl: '[أضف رابط الاعتماد]',
    image: '/images/certificates/placeholder.png',
  },
];
